import Axios from "axios";

var PrestadorServiceMixin = {
    methods: {
        getPrestador(documento) {
            documento = documento.replace(/([./-])/g, "");
            return Axios.get(
                this.CriarUrl({
                    resource: `api/prestador/${documento}`
                }),
                { withCredentials: true }
            );
        },
        deleteSujeiraPrestador(documento) {
            documento = documento.replace(/([./-])/g, "");
            return Axios.delete(
                this.CriarUrl({
                    resource: `api/prestador/${documento}/sujeira`
                }),
                { withCredentials: true }
            );
        }
    }
};

export default PrestadorServiceMixin;
